// Angular
import { Injectable } from '@angular/core';
import { concat as _concat, get as _get } from 'lodash';

import { PostFnolContext } from '../+state/post-fnol.models';
// Models
import { FnolFlowStepTitles } from '../containers/post-fnol.enum';

@Injectable({
  providedIn: 'root'
})
export class PostFnolRoutingService {
  constructor() {}

  getStepRoutePath(step: string, claimNumber: string, context: PostFnolContext): string[] {
    let stepPath = ['claims', claimNumber];
    if (step === FnolFlowStepTitles.REPORT) {
      stepPath = _concat(stepPath, ['post-fnol', 'report']);
    } else if (step === FnolFlowStepTitles.REPAIR) {
      stepPath = _concat(stepPath, ['post-fnol', 'repair']);
    } else if (step === FnolFlowStepTitles.PHOTOS) {
      stepPath = _concat(stepPath, ['post-fnol', 'photos']);
    } else if (step === FnolFlowStepTitles.RENTAL) {
      stepPath = _concat(stepPath, ['post-fnol', 'rental']);
    } else {
      // error scenario (third party already correct path for error)
      if (context === PostFnolContext.MY_ACCOUNT) {
        stepPath = ['claims'];
      }
    }
    return stepPath;
  }

  getClaimsPath(claimNumber: string, context: PostFnolContext) {
    if (context === PostFnolContext.THIRD_PARTY) {
      return ['claims', claimNumber];
    } else {
      return ['claims'];
    }
  }
}
